import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "../api/axios";
import { useAuth } from "../context/AuthProvider";
import './styles/LoginSignup.css';
import SEO from "../seo/SEO";
import config from "../config/config";

const ForgotPassword = () => {
  const { auth } = useAuth();
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    if (auth.isAuthenticated) {
      if (["admin", "siteadmin"].includes(auth.user?.role)) {
        navigate("/admin/dashboard");
      } else {
        navigate("/user");
      }
    }
  }, [auth, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");
    setError("");

    try {
        await axios.post("/api/auth/forgot-password", { email });
    } catch (err) {
        // Ignore specific error messages to avoid exposing account existence
    }

    // ✅ Always show the same message for security reasons
    setMessage("If there is an account associated with this email, you will receive a password reset link.");
  };


  return (

    <>
        <SEO
            robots="noindex, nofollow"
            title="Forgot Password - Withrow Knives"
            description="Reset your Withrow Knives account password. Enter your email to receive a password reset link."
            keywords={[
                "forgot password",
                "reset password",
                "Withrow Knives login",
                "recover account",
                "account recovery"
            ]}
            url={`${config.metadata.siteUrl}/forgot-password`}
            jsonLd={{
                "@context": "https://schema.org",
                "@type": "WebPage",
                "name": "Forgot Password - Withrow Knives",
                "url": `${config.metadata.siteUrl}/forgot-password`,
                "description": "Reset your Withrow Knives account password. Enter your email to receive a password reset link.",
                "breadcrumb": {
                    "@type": "BreadcrumbList",
                    "itemListElement": [
                        {
                            "@type": "ListItem",
                            "position": 1,
                            "name": "Home",
                            "item": config.metadata.siteUrl
                        },
                        {
                            "@type": "ListItem",
                            "position": 2,
                            "name": "Forgot Password",
                            "item": `${config.metadata.siteUrl}/forgot-password`
                        }
                    ]
                },
                "mainEntityOfPage": {
                    "@type": "WebPage",
                    "@id": `${config.metadata.siteUrl}/forgot-password`
                }
            }}
        />


    
      <div className="auth-page-wrapper">
        <div className="auth-container">
          <h2>Forgot Password</h2>
          <p>Remembered your password? <Link to="/login">Login</Link></p>

          {/* ✅ Ensure messages are accessible */}
          {message && <p className="success" aria-live="polite">{message}</p>}
          {error && <p className="error" aria-live="polite">{error}</p>}

          <form onSubmit={handleSubmit}>
            {/* ✅ Label for screen readers */}
            <label htmlFor="forgot-password-email" className="sr-only">Enter your email address</label>
            <input
              id="forgot-password-email"
              type="email"
              placeholder="Enter your email"
              onChange={(e) => setEmail(e.target.value)}
              required
            />

            <button type="submit" aria-label="Send password reset link">Send Reset Link</button>
          </form>
        </div>
      </div>
      </>
  );
};

export default ForgotPassword;
